/**
 * Appends the GraphQL operation name as a query param so New Relic AJAX
 * grouping can distinguish calls that all POST to the same `/graphql` path.
 */
export function graphqlHttpUri(
  baseUri: string,
  operationName: string | undefined
): string {
  if (operationName === undefined || operationName.length === 0) {
    return baseUri;
  }

  const separator = baseUri.includes("?") ? "&" : "?";
  return `${baseUri}${separator}operationName=${encodeURIComponent(operationName)}`;
}
